
import { ModalEditComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { FormRender } from '../../../../../../../forms/FormRenderer/types'
import { valueOrDefaultValue } from '../../../../../../../utils/globals/valueOrDefaultValue'
import { LittleModalCreateEdit } from '../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { permissionCheck } from '../../../../../../../baseComponents/PermissionChecker/function'
import { BillingRetentionModelType } from '@teinor/erp/types/company/config/billingGroup/billingRetention'
import { useParams } from 'react-router-dom'

type ModalCEConfigBillingRetentionProps = ModalEditComponentProps & {}

const ModalCEConfigBillingRetention: React.FC<ModalCEConfigBillingRetentionProps> = ({ allRowData, userPermissions, ...rest }) => {
    const { t } = useTwinTranslation()
    const { BillingGroupId } = useParams()

    const fields: FormRender<BillingRetentionModelType> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'name',
                    label: t('name', 'Nombre'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true,
                },
                {
                    name: 'code',
                    label: t('code', 'Clave'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'model',
                    label: t('model', 'Modelo'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'retention',
                    label: t('retention', 'Retención'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true,
                },
                {
                    name: 'id',
                    component: 'InputHidden'
                },
                {
                    name: 'BillingGroupId',
                    component: 'InputHidden',
                    value: BillingGroupId
                }
            ]
        },
    ]

    if (allRowData && userPermissions) {
        const parsedFields = valueOrDefaultValue(fields, userPermissions, allRowData)
        return (<LittleModalCreateEdit fields={parsedFields} url={'/api/app/config/billingGroup/billingRetention/updateBillingRetention'} translations={{ title: t('editTypeRetention', 'Editar Tipo de Retención'), button: t('save', 'Guardar') }} haveButtonPermissions={permissionCheck(userPermissions, 'update')} {...rest} />)
    }
    return (<LittleModalCreateEdit fields={fields} url={'/api/app/config/billingGroup/billingRetention/createBillingRetention'} translations={{
        title: t('createTyepRetention', 'Crear Tipo de Retención'),
        button: t('create', 'Crear')
    }} haveButtonPermissions={true} {...rest} />)
}


export default ModalCEConfigBillingRetention